import { connect } from "react-redux";
import { saveWidget, addBookmarkList } from "../../actions/layoutActions";
import BookmarkList from "./BookmarkList";
import type { AppDispatch, RootState } from "../../store";
import type { BookmarkListEntry } from "../../types/models";

const mapStateToProps = (state: RootState) => {
  const { isLoggedIn } = state.login;
  const { bookmarkLists, editWidgetIdentifiers } = state.layouts;
  return {
    isLoggedIn,
    bookmarkLists,
    editWidgetIdentifiers
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    onSubmit: ({
      widget_id,
      category,
      bookmarks
    }: {
      widget_id: string;
      category: string;
      bookmarks: BookmarkListEntry[];
    }) => {
      dispatch(saveWidget(widget_id));
      dispatch(addBookmarkList({ widget_id, category, bookmarks }));
    }
  };
};

const BookmarkListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(BookmarkList);

export default BookmarkListContainer;
